module.exports = __webpack_public_path__ + "static/media/Tsavo_Monique_Nieuw.af98a0ae.png";